// extracted by mini-css-extract-plugin
export var bounce = "_nx-1";
export var generatingText = "_nx-6";
export var lightning = "_nx-4";
export var popup = "_nx-5";
export var progressBar = "_nx-7";
export var progressFill = "_nx-8";
export var progressShimmer = "_nx-9";
export var progressText = "_nx-a";
export var shimmer = "_nx-3";
export var uploadIcon = "_nx-0";
export var uploadingText = "_nx-2";